import type {DefaultTheme} from '../api/types/user';
import {THEMES} from './main';

export function getApiTheme(uiTheme: string | null | undefined): DefaultTheme {
    if (uiTheme === THEMES.LIGHT_CONTRAST) return 'contrast';
    if (uiTheme === THEMES.DARK) return 'dark';
    return 'light';
}

export function getUiTheme(apiTheme: string | null | undefined): string {
    if (apiTheme === 'contrast') return THEMES.LIGHT_CONTRAST;
    if (apiTheme === 'dark') return THEMES.DARK;
    return THEMES.LIGHT;
}
